module.exports = __webpack_public_path__ + "static/media/about-02.72382f15.jpg";